import { Injectable } from '@angular/core';
import { HttpHeaders, HttpClient, HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';

export interface CurrencyDto {
  id: number;
  full_name: string | null;
  symbol: string | null;
  short_name: string | null;
  created_at: string | null;
  updated_at: string | null;
}

export interface CurrencyResponse {
  success: boolean;
  message: string;
  data: CurrencyDto;
}

export interface CurrencySavePayload {
  name: string;
  code: string;
  symbol?: string;
  enabled?: boolean;
}

export interface DateFormatSettingDto {
  id: number;
  small_date_format: string;
  date_format_with_time: string;
  long_date_format: string;
  long_date_format_with_time: string;
  smallDateFormat: string;
  dateFormatWithTime: string;
  longDateFormat: string;
  longDateFormatWithTime: string;
  created_at: string | null;
  updated_at: string | null;
}

export interface DateFormatSettingResponse {
  success: boolean;
  message: string;
  data: DateFormatSettingDto;
}

export interface DateFormatSettingSavePayload {
  small_date_format: string;
  date_format_with_time: string;
  long_date_format: string;
  long_date_format_with_time: string;
}

export interface LegalSettingsDto {
  id: number;
  terms_and_conditions: string;
  privacy_policy: string;
  termsAndConditions?: string;
  privacyPolicy?: string;
  created_at: string | null;
  updated_at: string | null;
}

export interface LegalSettingsResponse {
  success: boolean;
  message: string;
  data: LegalSettingsDto;
}

export interface LegalSettingsSavePayload {
  terms_and_conditions: string;
  privacy_policy: string;
}

export type CancelReasonUserType = 'rider' | 'driver' | 'both';

export interface CancelReasonDto {
  id: number;
  userType?: CancelReasonUserType;
  user_type?: CancelReasonUserType;
  reason: string;
  description: string | null;
  status: boolean;
  sortOrder?: number;
  sort_order?: number;
  created_at: string | null;
  updated_at: string | null;
}

export interface CancelReasonSavePayload {
  userType: CancelReasonUserType;
  reason: string;
  description?: string | null;
  status: boolean;
  sortOrder: number;
}

export interface CancelReasonListFilters {
  page: number;
  take: number;
  userType?: CancelReasonUserType | '';
  status?: boolean | null;
  search?: string;
}

export interface CancelReasonListResponse {
  success: boolean;
  message?: string;
  page: number;
  take: number;
  total_length: number;
  filtered_length: number;
  data: {
    cancelReasons: CancelReasonDto[];
  };
}

export interface CancelReasonResponse {
  success: boolean;
  message: string;
  data: CancelReasonDto;
}

@Injectable({
  providedIn: 'root'
})
export class HttpService {

  ApiUrl = environment.root;
  Token = ''

  constructor(private http: HttpClient) { }

  login(userName: string, password: string) {
    const credentials = { user_name: userName, password: password };
    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    };
    return this.http.post<LoginResult>(this.ApiUrl + 'operator/login', credentials, httpOptions).toPromise();
  }

  updateDriverStatus(data: any){
    this.Token = localStorage.getItem("token");

    const httpOptions = {
      headers: new HttpHeaders({
        'Authorization': `Bearer ${this.Token}`
      })
    };

    return this.http.patch(this.ApiUrl + 'driver/approve/by/admin', data, httpOptions);
  }




  // Agency Page API

  getAgencyData() {
    

    this.Token = localStorage.getItem("token");

    const httpOptions = {
      headers: new HttpHeaders({
        'Authorization': `Bearer ${this.Token}`
      })
    };

    return this.http.get(this.ApiUrl + 'agency', httpOptions);
  }


  getAgencyFilterData(agencyName: any, email: any, country: any, state: any, phone: any,
    firstName: any, lastName: any, from: any, to: any, status: any, approval_status:any) {
      

    this.Token = localStorage.getItem("token");

    const httpOptions = {
      headers: new HttpHeaders({
        'Authorization': `Bearer ${this.Token}`
      })
    };

    return this.http.get(
      `${this.ApiUrl}agency?agency_name=${agencyName}&email=${email}&country=${country}&state=${state}&phone=${phone}&contact_person_first_name=${firstName}&contact_person_last_name=${lastName}&registered_from_date=${from}&registered_to_date=${to}&status=${status}&approval_status=${approval_status}`
      , httpOptions);
  }


  AgencyPageSize(pageIndex: any, pageSize: any) {
      

    this.Token = localStorage.getItem("token");

    const httpOptions = {
      headers: new HttpHeaders({
        'Authorization': `Bearer ${this.Token}`
      })
    };

    return this.http.get(
      `${this.ApiUrl}agency?page=${pageIndex}&take=${pageSize}`
      , httpOptions);
  }


  deleteAgency(id: any) {
    this.Token = localStorage.getItem("token");

    const httpOptions = {
      headers: new HttpHeaders({
        'Authorization': `Bearer ${this.Token}`
      })
    };

    return this.http.delete(this.ApiUrl + 'agency/' + id, httpOptions);
  }



  

  getAgencyDetail(id: any){
    this.Token = localStorage.getItem("token");

    const httpOptions = {
      headers: new HttpHeaders({
        'Authorization': `Bearer ${this.Token}`
      })
    };
    return this.http.get(this.ApiUrl + 'agency/' + id, httpOptions);
  }

  getAgencyList(){
    this.Token = localStorage.getItem("token");

    const httpOptions = {
      headers: new HttpHeaders({
        'Authorization': `Bearer ${this.Token}`
      })
    };
    return this.http.get(this.ApiUrl + 'agency/names', httpOptions);
  }




  //Vehicle Types Apis

  getVehicleType(){
    this.Token = localStorage.getItem("token");

    const httpOptions = {
      headers: new HttpHeaders({
        'Authorization': `Bearer ${this.Token}`
      })
    };
    return this.http.get(this.ApiUrl + 'vehicle/type', httpOptions);
  }

  
  deleteVehicleType(id: any) {
    this.Token = localStorage.getItem("token");

    const httpOptions = {
      headers: new HttpHeaders({
        'Authorization': `Bearer ${this.Token}`
      })
    };

    return this.http.delete(this.ApiUrl + 'vehicle/type/' + id, httpOptions);
  }


  updateVehicleType(data: any, id: number) {
    this.Token = localStorage.getItem("token");

    const httpOptions = {
      headers: new HttpHeaders({
        'Authorization': `Bearer ${this.Token}`
      })
    };
    return this.http.patch(this.ApiUrl + 'vehicle/type/' + id, data, httpOptions);
  }

  saveVehicleType(data: any) {
    this.Token = localStorage.getItem("token");

    const httpOptions = {
      headers: new HttpHeaders({
        'Authorization': `Bearer ${this.Token}`
      })
    };
    return this.http.post(this.ApiUrl + 'vehicle/type', data, httpOptions);
  }





  sendWelcomeEmail(data: any){
    this.Token = localStorage.getItem("token");

    const httpOptions = {
      headers: new HttpHeaders({
        'Authorization': `Bearer ${this.Token}`
      })
    };
    return this.http.post(this.ApiUrl + 'agency/send/welcome/email', data, httpOptions);
  }

//Bussiness Types Apis

  getBusinessType(){
    this.Token = localStorage.getItem("token");

    const httpOptions = {
      headers: new HttpHeaders({
        'Authorization': `Bearer ${this.Token}`
      })
    };
    return this.http.get(this.ApiUrl + 'business/type', httpOptions);
  }
  
  deleteBussinessType(id: any) {
    this.Token = localStorage.getItem("token");

    const httpOptions = {
      headers: new HttpHeaders({
        'Authorization': `Bearer ${this.Token}`
      })
    };

    return this.http.delete(this.ApiUrl + 'business/type/' + id, httpOptions);
  }


  updateBussinessType(data: any, id: number) {
    this.Token = localStorage.getItem("token");

    const httpOptions = {
      headers: new HttpHeaders({
        'Authorization': `Bearer ${this.Token}`
      })
    };
    return this.http.patch(this.ApiUrl + 'business/type/' + id, data, httpOptions);
  }

  updateRiderStatus(data: any, id: number) {
    this.Token = localStorage.getItem("token");

    const httpOptions = {
      headers: new HttpHeaders({
        'Authorization': `Bearer ${this.Token}`
      })
    };
    return this.http.patch(this.ApiUrl + 'rider/status/' + id, data, httpOptions);
  }

  updateRiderApprovalStatus(data: any, id: number) {
    this.Token = localStorage.getItem("token");

    const httpOptions = {
      headers: new HttpHeaders({
        'Authorization': `Bearer ${this.Token}`
      })
    };
    return this.http.patch(this.ApiUrl + 'rider/status/' + id, data, httpOptions);
  }

  
  saveBussinessType(data: any) {
    this.Token = localStorage.getItem("token");

    const httpOptions = {
      headers: new HttpHeaders({
        'Authorization': `Bearer ${this.Token}`
      })
    };
    return this.http.post(this.ApiUrl + 'business/type', data, httpOptions);
  }





    // Driver Page API


  getDriversList(take: any, page: any, firstName: any, mobileNumber: any, status: any, agencyName: any) {
    this.Token = localStorage.getItem("token");

    let params = new HttpParams()
      .set('take', String(take ?? 10))
      .set('page', String(page ?? 1));

    const firstNameValue = firstName != null ? String(firstName).trim() : '';
    const mobileNumberValue = mobileNumber != null ? String(mobileNumber).trim() : '';
    const agencyNameValue = agencyName != null ? String(agencyName).trim() : '';

    const statusValues = Array.isArray(status)
      ? status.map((s) => String(s ?? '').trim()).filter(Boolean)
      : String(status ?? '')
          .split(',')
          .map((s) => s.trim())
          .filter(Boolean);

    if (firstNameValue) {
      params = params.set('driver_firstName', firstNameValue);
      params = params.set('driver_name', firstNameValue);
    }
    if (mobileNumberValue) {
      params = params.set('driver_mobileNumber', mobileNumberValue);
    }
    if (statusValues.length === 1) {
      params = params.set('driver_status', statusValues[0]);
    } else if (statusValues.length > 1) {
      // Approved drivers are stored as offline/online/in service — send all for filter match.
      statusValues.forEach((value, index) => {
        params = index === 0 ? params.set('driver_status', value) : params.append('driver_status', value);
      });
    }
    if (agencyNameValue) {
      params = params.set('agency_name', agencyNameValue);
    }

    const httpOptions = {
      headers: new HttpHeaders({
        'Authorization': `Bearer ${this.Token}`
      }),
      params
    };

    return this.http.get(this.ApiUrl + 'driver', httpOptions);
  }


  getSingleDriver(id: any){
    this.Token = localStorage.getItem("token");

    const httpOptions = {
      headers: new HttpHeaders({
        'Authorization': `Bearer ${this.Token}`
      })
    };

    return this.http.get(this.ApiUrl + `driver/${id}`, httpOptions);
  }





  // Country Setting API

  getCountry() {
    

    this.Token = localStorage.getItem("token");

    const httpOptions = {
      headers: new HttpHeaders({
        'Authorization': `Bearer ${this.Token}`
      })
    };


    return this.http.get(this.ApiUrl + 'country', httpOptions);
  }

  getCountryByPage(pageIndex: number, pageSize: number) {
    this.Token = localStorage.getItem("token");

    const httpOptions = {
      headers: new HttpHeaders({
        'Authorization': `Bearer ${this.Token}`
      })
    };

    return this.http.get(`${this.ApiUrl}country?page=${pageIndex}&take=${pageSize}`, httpOptions);
  }

  saveCountry(data: any) {
    
    this.Token = localStorage.getItem("token");

    const httpOptions = {
      headers: new HttpHeaders({
        'Authorization': `Bearer ${this.Token}`
      })
    };

    return this.http.post(this.ApiUrl + 'country', data, httpOptions);
  }

  deleteCountry(id: any) {
    this.Token = localStorage.getItem("token");

    const httpOptions = {
      headers: new HttpHeaders({
        'Authorization': `Bearer ${this.Token}`
      })
    };

    return this.http.delete(this.ApiUrl + 'country/' + id, httpOptions);
  }

  deleteFlag(id: any) {
    this.Token = localStorage.getItem("token");

    const httpOptions = {
      headers: new HttpHeaders({
        'Authorization': `Bearer ${this.Token}`
      })
    };

    return this.http.delete(this.ApiUrl + 'country/flag/' + id, httpOptions);
  }

  updateCountry(data: any, id: number) {
    this.Token = localStorage.getItem("token");

    const httpOptions = {
      headers: new HttpHeaders({
        'Authorization': `Bearer ${this.Token}`
      })
    };
    return this.http.patch(this.ApiUrl + 'country/' + id, data, httpOptions);
  }



  // State Setting API

  getStates() {
    
    this.Token = localStorage.getItem("token");

    const httpOptions = {
      headers: new HttpHeaders({
        'Authorization': `Bearer ${this.Token}`
      })
    };
    return this.http.get(this.ApiUrl + 'states/country', httpOptions);
  }

  getStatesByPage(pageIndex: any, pageSize: any) {
    
    this.Token = localStorage.getItem("token");

    const httpOptions = {
      headers: new HttpHeaders({
        'Authorization': `Bearer ${this.Token}`
      })
    };
    return this.http.get(
      `${this.ApiUrl}states/country?page=${pageIndex}&take=${pageSize}`
      , httpOptions);
  }

  saveState(data: any) {
    
    this.Token = localStorage.getItem("token");

    const httpOptions = {
      headers: new HttpHeaders({
        'Authorization': `Bearer ${this.Token}`
      })
    };
    return this.http.post(this.ApiUrl + 'states/country', data, httpOptions);
  }

  deleteState(id: any) {
    this.Token = localStorage.getItem("token");

    const httpOptions = {
      headers: new HttpHeaders({
        'Authorization': `Bearer ${this.Token}`
      })
    };
    return this.http.delete(this.ApiUrl + 'states/country/' + id, httpOptions);
  }

  updateState(data: any, id: number) {
    this.Token = localStorage.getItem("token");

    const httpOptions = {
      headers: new HttpHeaders({
        'Authorization': `Bearer ${this.Token}`
      })
    };

    return this.http.patch(this.ApiUrl + 'states/country/' + id, data, httpOptions);
  }


  getStatesByCountry(name: any) {
    
    this.Token = localStorage.getItem("token");

    const httpOptions = {
      headers: new HttpHeaders({
        'Authorization': `Bearer ${this.Token}`
      })
    };
    return this.http.get(this.ApiUrl + `states/country/enabled?country_name=${name}`, httpOptions);
  }


  //************** Complaint Page API **************//

  // getComplaints(pageSize: any, pageIndex: any){
  //   this.Token = localStorage.getItem("token");
  //   const agencyId = localStorage.getItem('agencyId')

  //   const httpOptions = {
  //     headers: new HttpHeaders({
  //       'Authorization': `Bearer ${this.Token}`
  //     })
  //   };

  //   return this.http.get(`${this.ApiUrl}complaint/by/agency/${agencyId}?take=${pageSize}&page=${pageIndex}`, httpOptions);
  // }


  // getComplaintsFilter(pageSize: any, pageIndex: any, complaintBy: any, dateFrom: any, dateTo: any){
  //   this.Token = localStorage.getItem("token");
  //   const agencyId = localStorage.getItem('agencyId')

  //   const httpOptions = {
  //     headers: new HttpHeaders({
  //       'Authorization': `Bearer ${this.Token}`
  //     })
  //   };

  //   return this.http.get(`${this.ApiUrl}complaint/by/agency/${agencyId}?take=
  //   ${pageSize}&page=${pageIndex}&complaintBy=${complaintBy}&dateFrom=${dateFrom}&dateTo=${dateTo}`, httpOptions);
  // }


  getSingleComplaint(id: any){
    this.Token = localStorage.getItem("token");

    const httpOptions = {
      headers: new HttpHeaders({
        'Authorization': `Bearer ${this.Token}`
      })
    };

    return this.http.get(`${this.ApiUrl}complaint/${id}`, httpOptions);
  }

  getUserTripHistory(userId: any, userType: string = 'rider') {
    this.Token = localStorage.getItem("token");

    const httpOptions = {
      headers: new HttpHeaders({
        'Authorization': `Bearer ${this.Token}`
      })
    };

    return this.http.get(
      `${this.ApiUrl}requests/user/trip-history?userId=${encodeURIComponent(String(userId))}&userType=${encodeURIComponent(userType)}`,
      httpOptions
    );
  }

  getUserComplaintHistory(userId: any, userType: string = 'rider') {
    this.Token = localStorage.getItem("token");

    const httpOptions = {
      headers: new HttpHeaders({
        'Authorization': `Bearer ${this.Token}`
      })
    };

    return this.http.get(
      `${this.ApiUrl}complaint/user/history?userId=${encodeURIComponent(String(userId))}&userType=${encodeURIComponent(userType)}`,
      httpOptions
    );
  }

  getComplaintRefundPreview(id: any) {
    this.Token = localStorage.getItem("token");

    const httpOptions = {
      headers: new HttpHeaders({
        'Authorization': `Bearer ${this.Token}`
      })
    };

    return this.http.get(`${this.ApiUrl}complaint/${id}/refund/preview`, httpOptions);
  }

  refundComplaint(id: any, data: {
    amount: number;
    currency?: string;
    reason: string;
    markReviewed?: boolean;
  }) {
    this.Token = localStorage.getItem("token");

    const httpOptions = {
      headers: new HttpHeaders({
        'Authorization': `Bearer ${this.Token}`,
        'Content-Type': 'application/json'
      })
    };

    return this.http.post(`${this.ApiUrl}complaint/${id}/refund`, data, httpOptions);
  }

  markComplaintReviewed(id: any, data: { status: string; reviewNote?: string }) {
    this.Token = localStorage.getItem("token");

    const httpOptions = {
      headers: new HttpHeaders({
        'Authorization': `Bearer ${this.Token}`,
        'Content-Type': 'application/json'
      })
    };

    return this.http.patch(`${this.ApiUrl}complaint/${id}/reviewed`, data, httpOptions);
  }



  // Company Setting API

  getCompanySetting() {
    

    this.Token = localStorage.getItem("token");

    const httpOptions = {
      headers: new HttpHeaders({
        'Authorization': `Bearer ${this.Token}`
      })
    };

    return this.http.get(this.ApiUrl + 'company', httpOptions);
  }

  saveCompanySetting(data: any) {
    

    this.Token = localStorage.getItem("token");

    const httpOptions = {
      headers: new HttpHeaders({
        'Authorization': `Bearer ${this.Token}`
      })
    };

    return this.http.post(this.ApiUrl + 'company', data, httpOptions);
  }

  updateCompanySetting(data: any) {
    

    this.Token = localStorage.getItem("token");

    const httpOptions = {
      headers: new HttpHeaders({
        'Authorization': `Bearer ${this.Token}`
      })
    };

    return this.http.patch(this.ApiUrl + 'company/1', data, httpOptions);
  }


  // Application Setting API

  getApplicationSetting() {
    

    this.Token = localStorage.getItem("token");

    const httpOptions = {
      headers: new HttpHeaders({
        'Authorization': `Bearer ${this.Token}`
      })
    };

    return this.http.get(this.ApiUrl + 'application', httpOptions);
  }

  saveApplicationSetting(data: any) {
    

    this.Token = localStorage.getItem("token");

    const httpOptions = {
      headers: new HttpHeaders({
        'Authorization': `Bearer ${this.Token}`
      })
    };

    return this.http.post(this.ApiUrl + 'application', data, httpOptions);
  }

  updateApplicationSetting(data: any) {
    

    this.Token = localStorage.getItem("token");

    const httpOptions = {
      headers: new HttpHeaders({
        'Authorization': `Bearer ${this.Token}`
      })
    };

    return this.http.patch(this.ApiUrl + 'application/1', data, httpOptions);
  }


    // Subscription Setting API

    getSubscriptionSetting() {
    

      this.Token = localStorage.getItem("token");
  
      const httpOptions = {
        headers: new HttpHeaders({
          'Authorization': `Bearer ${this.Token}`
        })
      };
  
      return this.http.get(this.ApiUrl + 'subscription/setting', httpOptions);
    }

    saveSubscriptionSetting(data: any) {
  
      this.Token = localStorage.getItem("token");
      
      const httpOptions = {
        headers: new HttpHeaders({
          'Authorization': `Bearer ${this.Token}`
        })
      };
  
      return this.http.post(this.ApiUrl + 'subscription/setting', data, httpOptions);
    }


    //Subscription Apis

    getAllSubscriptionsByAgency(id : any) {
  
      this.Token = localStorage.getItem("token");
  
      const httpOptions = {
        headers: new HttpHeaders({
          'Authorization': `Bearer ${this.Token}`
        })
      };
  
      return this.http.get(this.ApiUrl + 'subscription/by/agency/' + id, httpOptions);
    }

    
    getAllSubscriptionByFilter(pageSize: any, pageIndex: any,status:any, paid:any, agency_name:any, created_at:any, expiresIn:any, agencyId:any) {
  
      this.Token = localStorage.getItem("token");
  
      const httpOptions = {
        headers: new HttpHeaders({
          'Authorization': `Bearer ${this.Token}`
        })
      };
  
      return this.http.get(this.ApiUrl + `subscription?take=${pageSize}&page=${pageIndex}&status=${status}&paid=${paid}&agency_name=${agency_name}&created_at=${created_at}&expiresIn=${expiresIn}&agencyId=${agencyId}`, httpOptions);
    }


    //create free trial subscription
    saveFreeTrailSubscription(data: any) {
    
      this.Token = localStorage.getItem("token");
  
      const httpOptions = {
        headers: new HttpHeaders({
          'Authorization': `Bearer ${this.Token}`
        })
      };
  
      return this.http.post(this.ApiUrl + 'subscription/free-trial', data, httpOptions);
    }

    //create regular subscription
    saveRegularSubscription(data: any) {
    
      this.Token = localStorage.getItem("token");
  
      const httpOptions = {
        headers: new HttpHeaders({
          'Authorization': `Bearer ${this.Token}`
        })
      };
  
      return this.http.post(this.ApiUrl + 'subscription', data, httpOptions);
    }

    //create enterprise subscription
    saveEnterpriseSubscription(data: any) {
    
      this.Token = localStorage.getItem("token");
  
      const httpOptions = {
        headers: new HttpHeaders({
          'Authorization': `Bearer ${this.Token}`
        })
      };
  
      return this.http.post(this.ApiUrl + 'subscription/enterprise', data, httpOptions);
    }


    //cancel subscription
    cancelSubscription(data: any) {
    
      this.Token = localStorage.getItem("token");
  
      const httpOptions = {
        headers: new HttpHeaders({
          'Authorization': `Bearer ${this.Token}`
        })
      };
  
      return this.http.post(this.ApiUrl + 'subscription/cancel', data, httpOptions);
    }


    //topup
    topupSubscription(data: any) {
    
      this.Token = localStorage.getItem("token");
  
      const httpOptions = {
        headers: new HttpHeaders({
          'Authorization': `Bearer ${this.Token}`
        })
      };
  
      return this.http.post(this.ApiUrl + 'subscription/topup', data, httpOptions);
    }



    //Create Subscription
    createSubscription(data: any) {
    
      this.Token = localStorage.getItem("token");
  
      const httpOptions = {
        headers: new HttpHeaders({
          'Authorization': `Bearer ${this.Token}`
        })
      };
  
      return this.http.post(this.ApiUrl + 'subscription', data, httpOptions);
    }

  // Currency Setting API

  getCurrency(): Observable<CurrencyResponse> {
    
    this.Token = localStorage.getItem("token");

    const httpOptions = {
      headers: new HttpHeaders({
        'Authorization': `Bearer ${this.Token}`
      })
    };

    return this.http.get<CurrencyResponse>(this.ApiUrl + 'currency/', httpOptions);
  }

  createCurrency(data: CurrencySavePayload): Observable<CurrencyResponse> {
    

    this.Token = localStorage.getItem("token");

    const httpOptions = {
      headers: new HttpHeaders({
        'Authorization': `Bearer ${this.Token}`
      })
    };

    return this.http.post<CurrencyResponse>(this.ApiUrl + 'currency/', data, httpOptions);
  }

  updateCurrency(id: number, data: Partial<CurrencySavePayload>): Observable<any> {
    

    this.Token = localStorage.getItem("token");

    const httpOptions = {
      headers: new HttpHeaders({
        'Authorization': `Bearer ${this.Token}`
      })
    };
    return this.http.patch(this.ApiUrl + 'currency/' + id, data, httpOptions);
  }

  getCurrencySetting(): Observable<CurrencyResponse> {
    return this.getCurrency();
  }

  saveCurrencySetting(data: CurrencySavePayload): Observable<CurrencyResponse> {
    return this.createCurrency(data);
  }

  updateCurrencySetting(data: Partial<CurrencySavePayload>, id = 1): Observable<any> {
    return this.updateCurrency(id, data);
  }


  // Date Format Setting API

  getDateFormatSetting(): Observable<DateFormatSettingResponse> {
    this.Token = localStorage.getItem("token");

    const httpOptions = {
      headers: new HttpHeaders({
        'Authorization': `Bearer ${this.Token}`
      })
    };

    return this.http.get<DateFormatSettingResponse>(this.ApiUrl + 'date-format/', httpOptions);
  }

  getDateFormatSettingById(id: number): Observable<DateFormatSettingResponse> {
    this.Token = localStorage.getItem("token");

    const httpOptions = {
      headers: new HttpHeaders({
        'Authorization': `Bearer ${this.Token}`
      })
    };

    return this.http.get<DateFormatSettingResponse>(this.ApiUrl + 'date-format/' + id, httpOptions);
  }

  createDateFormatSetting(data: DateFormatSettingSavePayload): Observable<DateFormatSettingResponse> {
    this.Token = localStorage.getItem("token");

    const httpOptions = {
      headers: new HttpHeaders({
        'Authorization': `Bearer ${this.Token}`
      })
    };

    return this.http.post<DateFormatSettingResponse>(this.ApiUrl + 'date-format/', data, httpOptions);
  }

  updateDateFormatSetting(id: number, data: Partial<DateFormatSettingSavePayload>): Observable<DateFormatSettingResponse> {
    this.Token = localStorage.getItem("token");

    const httpOptions = {
      headers: new HttpHeaders({
        'Authorization': `Bearer ${this.Token}`
      })
    };

    return this.http.patch<DateFormatSettingResponse>(this.ApiUrl + 'date-format/' + id, data, httpOptions);
  }

  deleteDateFormatSetting(id: number): Observable<any> {
    this.Token = localStorage.getItem("token");

    const httpOptions = {
      headers: new HttpHeaders({
        'Authorization': `Bearer ${this.Token}`
      })
    };

    return this.http.delete(this.ApiUrl + 'date-format/' + id, httpOptions);
  }

  // Legal Settings (Terms & Conditions / Privacy Policy)

  getLegalSettings(): Observable<LegalSettingsResponse> {
    this.Token = localStorage.getItem("token");

    const httpOptions = {
      headers: new HttpHeaders({
        'Authorization': `Bearer ${this.Token}`
      })
    };

    return this.http.get<LegalSettingsResponse>(this.ApiUrl + 'legal-settings/', httpOptions);
  }

  createLegalSettings(data: LegalSettingsSavePayload): Observable<LegalSettingsResponse> {
    this.Token = localStorage.getItem("token");

    const httpOptions = {
      headers: new HttpHeaders({
        'Authorization': `Bearer ${this.Token}`
      })
    };

    return this.http.post<LegalSettingsResponse>(this.ApiUrl + 'legal-settings/', data, httpOptions);
  }

  updateLegalSettings(id: number, data: Partial<LegalSettingsSavePayload>): Observable<LegalSettingsResponse> {
    this.Token = localStorage.getItem("token");

    const httpOptions = {
      headers: new HttpHeaders({
        'Authorization': `Bearer ${this.Token}`
      })
    };

    return this.http.patch<LegalSettingsResponse>(this.ApiUrl + 'legal-settings/' + id, data, httpOptions);
  }

  deleteLegalSettings(id: number): Observable<any> {
    this.Token = localStorage.getItem("token");

    const httpOptions = {
      headers: new HttpHeaders({
        'Authorization': `Bearer ${this.Token}`
      })
    };

    return this.http.delete(this.ApiUrl + 'legal-settings/' + id, httpOptions);
  }

  // Cancel Reasons API

  getCancelReasons(filters: CancelReasonListFilters): Observable<CancelReasonListResponse> {
    this.Token = localStorage.getItem("token");

    let params = new HttpParams()
      .set('page', String(filters.page))
      .set('take', String(filters.take));

    if (filters.userType) {
      params = params.set('userType', filters.userType);
    }

    if (filters.status !== null && filters.status !== undefined) {
      params = params.set('status', String(filters.status));
    }

    if (filters.search) {
      params = params.set('search', filters.search);
    }

    const httpOptions = {
      headers: new HttpHeaders({
        'Authorization': `Bearer ${this.Token}`
      }),
      params
    };

    return this.http.get<CancelReasonListResponse>(this.ApiUrl + 'cancel-reasons/admin', httpOptions);
  }

  getCancelReason(id: number): Observable<CancelReasonResponse> {
    this.Token = localStorage.getItem("token");

    const httpOptions = {
      headers: new HttpHeaders({
        'Authorization': `Bearer ${this.Token}`
      })
    };

    return this.http.get<CancelReasonResponse>(this.ApiUrl + 'cancel-reasons/' + id, httpOptions);
  }

  createCancelReason(data: CancelReasonSavePayload): Observable<CancelReasonResponse> {
    this.Token = localStorage.getItem("token");

    const httpOptions = {
      headers: new HttpHeaders({
        'Authorization': `Bearer ${this.Token}`
      })
    };

    return this.http.post<CancelReasonResponse>(this.ApiUrl + 'cancel-reasons', data, httpOptions);
  }

  updateCancelReason(id: number, data: Partial<CancelReasonSavePayload>): Observable<CancelReasonResponse> {
    this.Token = localStorage.getItem("token");

    const httpOptions = {
      headers: new HttpHeaders({
        'Authorization': `Bearer ${this.Token}`
      })
    };

    return this.http.patch<CancelReasonResponse>(this.ApiUrl + 'cancel-reasons/' + id, data, httpOptions);
  }

  deleteCancelReason(id: number): Observable<any> {
    this.Token = localStorage.getItem("token");

    const httpOptions = {
      headers: new HttpHeaders({
        'Authorization': `Bearer ${this.Token}`
      })
    };

    return this.http.delete(this.ApiUrl + 'cancel-reasons/' + id, httpOptions);
  }



  // Payment Gate Setting API

  // Paypal API


  getPaypalSetting() {
    this.Token = localStorage.getItem("token");

    const httpOptions = {
      headers: new HttpHeaders({
        'Authorization': `Bearer ${this.Token}`
      })
    };

    return this.http.get(this.ApiUrl + 'payment/config', httpOptions);
  }

  savePaypalSetting(data: any) {
    

    this.Token = localStorage.getItem("token");

    const httpOptions = {
      headers: new HttpHeaders({
        'Authorization': `Bearer ${this.Token}`
      })
    };

    return this.http.post(this.ApiUrl + 'payment/config', data, httpOptions);
  }


  updatePaypalSetting(data: any, id: any) {
    

    this.Token = localStorage.getItem("token");

    const httpOptions = {
      headers: new HttpHeaders({
        'Authorization': `Bearer ${this.Token}`
      })
    };

    return this.http.patch(this.ApiUrl + 'payment/config/' + id, data, httpOptions);
  }




  // SMTP Setting API


  getSMTPSetting(): Observable<any> {
    

    this.Token = localStorage.getItem("token");

    const httpOptions = {
      headers: new HttpHeaders({
        'Authorization': `Bearer ${this.Token}`
      })
    };

    return this.http.get(this.ApiUrl + 'config/smtp/settings', httpOptions);
  }


  saveSMTPSetting(data: any): Observable<any> {
    

    this.Token = localStorage.getItem("token");

    const httpOptions = {
      headers: new HttpHeaders({
        'Authorization': `Bearer ${this.Token}`
      })
    };

    return this.http.post(this.ApiUrl + 'config/smtp', { data }, httpOptions);
  }

  updateSMTPSetting(data: any): Observable<any> {
    

    this.Token = localStorage.getItem("token");

    const httpOptions = {
      headers: new HttpHeaders({
        'Authorization': `Bearer ${this.Token}`
      })
    };

    return this.http.patch(this.ApiUrl + 'config/smtp', { data }, httpOptions);
  }


  // Developer Setting API


  saveDeveloperSetting(data: any) {
    

    this.Token = localStorage.getItem("token");

    const httpOptions = {
      headers: new HttpHeaders({
        'Authorization': `Bearer ${this.Token}`
      })
    };

    return this.http.post(this.ApiUrl + 'config/smtp/developer/settings', data, httpOptions);
  }


  updateDeveloperSetting(data: any) {
    

    this.Token = localStorage.getItem("token");

    const httpOptions = {
      headers: new HttpHeaders({
        'Authorization': `Bearer ${this.Token}`
      })
    };

    return this.http.patch(this.ApiUrl + 'config/smtp/developer/settings', data, httpOptions);
  }


  //Reports Apis
  getAgencyPayableReport(agencyId: number, startDate: string, endDate: string) {
      

    this.Token = localStorage.getItem("token");

    const httpOptions = {
      headers: new HttpHeaders({
        'Authorization': `Bearer ${this.Token}`
      }),
      responseType: 'blob' as 'json' // Set the response type to blob
    };

    return this.http.get(
      `${this.ApiUrl}reports/agency/rides?startDate=${startDate}&agencyId=${agencyId}&endDate=${endDate}`
      , httpOptions);
  }


  getAllRidesPayment(startDate: string, endDate: string) {
      

    this.Token = localStorage.getItem("token");

    const httpOptions = {
      headers: new HttpHeaders({
        'Authorization': `Bearer ${this.Token}`
      }),
      responseType: 'blob' as 'json' // Set the response type to blob
    };

    return this.http.get(
      `${this.ApiUrl}reports/rides/payment/received/by/admin?startDate=${startDate}&endDate=${endDate}`
      , httpOptions);
  }


  //feedbacks




  getFeedbacksFilter(pageSize: any, pageIndex: any, isReviewed: any, provider:any){
    this.Token = localStorage.getItem("token");
    // const agencyId = localStorage.getItem('agencyId')

    const httpOptions = {
      headers: new HttpHeaders({
        'Authorization': `Bearer ${this.Token}`
      })
    };

    return this.http.get(`${this.ApiUrl}feedback/?take=${pageSize}&page=${pageIndex}&isReviewed=${isReviewed}&provider=${provider}`, httpOptions);
  }


  getSingleFeedback(id: any){
    this.Token = localStorage.getItem("token");

    const httpOptions = {
      headers: new HttpHeaders({
        'Authorization': `Bearer ${this.Token}`
      })
    };

    return this.http.get(`${this.ApiUrl}feedback/${id}`, httpOptions);
  }


  markFeedbackReviewed(id: any, data:any){
    this.Token = localStorage.getItem("token");

    const httpOptions = {
      headers: new HttpHeaders({
        'Authorization': `Bearer ${this.Token}`
      })
    };

    return this.http.patch(`${this.ApiUrl}feedback/mark/reviewed/${id}`, data, httpOptions);
  }


  //feedback Types Apis

 

  getFeedbackTypes(pageIndex: any, pageSize: any) {
    
    this.Token = localStorage.getItem("token");

    const httpOptions = {
      headers: new HttpHeaders({
        'Authorization': `Bearer ${this.Token}`
      })
    };
    return this.http.get(
      `${this.ApiUrl}feedback/type?page=${pageIndex}&take=${pageSize}`
      , httpOptions);
  }

  getEnabledFeedbackTypes() {
    
    this.Token = localStorage.getItem("token");

    const httpOptions = {
      headers: new HttpHeaders({
        'Authorization': `Bearer ${this.Token}`
      })
    };
    return this.http.get(
      `${this.ApiUrl}feedback/type/enabled`
      , httpOptions);
  }

  saveFeedbackType(data: any) {
    
    this.Token = localStorage.getItem("token");

    const httpOptions = {
      headers: new HttpHeaders({
        'Authorization': `Bearer ${this.Token}`
      })
    };
    return this.http.post(this.ApiUrl + 'feedback/type', data, httpOptions);
  }

  deleteFeedbackType(id: any) {
    this.Token = localStorage.getItem("token");

    const httpOptions = {
      headers: new HttpHeaders({
        'Authorization': `Bearer ${this.Token}`
      })
    };
    return this.http.delete(this.ApiUrl + 'feedback/type/' + id, httpOptions);
  }

  updateFeedbackType(data: any, id: number) {
    this.Token = localStorage.getItem("token");

    const httpOptions = {
      headers: new HttpHeaders({
        'Authorization': `Bearer ${this.Token}`
      })
    };

    return this.http.patch(this.ApiUrl + 'feedback/type/' + id, data, httpOptions);
  }


  //Welcome mail
  sendWelcomeMailRider(data: any) {
    this.Token = localStorage.getItem("token");

    const httpOptions = {
      headers: new HttpHeaders({
        'Authorization': `Bearer ${this.Token}`
      })
    };
    return this.http.post(this.ApiUrl + 'rider/send/welcome/email', data, httpOptions);
  }


  //services list
  getAllServices(){
    this.Token = localStorage.getItem("token");

    const httpOptions = {
      headers: new HttpHeaders({
        'Authorization': `Bearer ${this.Token}`
      })
    };

    return this.http.get(`${this.ApiUrl}service`, httpOptions);
  }




// Disputes apis
getDisputes(status:any, pageIndex: any, pageSize: any) {
    
  this.Token = localStorage.getItem("token");

  const httpOptions = {
    headers: new HttpHeaders({
      'Authorization': `Bearer ${this.Token}`
    })
  };
  return this.http.get(
    `${this.ApiUrl}trips/dispute/by/admin?status=${status}&page=${pageIndex}&take=${pageSize}`
    , httpOptions);
}


updateDispute(data: any, id: number){
  this.Token = localStorage.getItem("token");

    const httpOptions = {
      headers: new HttpHeaders({
        'Authorization': `Bearer ${this.Token}`
      })
    };
    return this.http.patch(this.ApiUrl + 'dispute/' + id, data, httpOptions);
}


updateAgency(data: any, id: number) {
  this.Token = localStorage.getItem("token");

  const httpOptions = {
    headers: new HttpHeaders({
      'Authorization': `Bearer ${this.Token}`
    })
  };
  return this.http.patch(this.ApiUrl + 'driver/by/agency/' + id, data, httpOptions);
}

updateAgencyData(data: any, id: number) {
  this.Token = localStorage.getItem("token");

  const httpOptions = {
    headers: new HttpHeaders({
      'Authorization': `Bearer ${this.Token}`
    })
  };
  return this.http.patch(this.ApiUrl + 'agency/' + id, data, httpOptions);
}


}




export interface LoginResult {
  sessionId: string;
  token: string;
  /** When backend returns current operator, stored for guards / sidebar (optional). */
  operator?: Record<string, unknown>;
  user?: Record<string, unknown>;
}